module.exports = __webpack_public_path__ + "img/card_walk.a9678d7b.gif";